import * as React from 'react';
import { UNSAFE_RouteContext } from 'react-router-dom';

export function usePathPattern() {
  const routeContext = React.useContext(UNSAFE_RouteContext);

  const path = React.useMemo(() => {
    const path = routeContext.matches
      .map(({ route: { path } }) => path)
      .flatMap((path) => (path !== undefined ? [path] : [])) // remove matches without path
      .map((path) => path.replace(/^\//, '')) // remove leading '/' if present; we always add it for consistency
      .join('/');

    if (path === '*') {
      return path;
    }
    return path ? `/${path}` : '/';
  }, [routeContext.matches]);
  return path;
}
